import { IconArrowLeft, Popup, SchemaFilterType, Table } from '@ui/src';
import { useAppSelector } from '@store';
import useExpiredDocuments from '../hooks/use-expired-documents';
import { ExpiredDocumentsTypes } from '../types';
import { columns, columnsLabels } from '../variables/expired';

import cn from '../styles.module.css';

const ExpiredDocuments = ({
  type,
  customerId,
  activePermissions,
  setDeletePopupVisible,
  deleteDocumentIsSuccess,
  setSubMenuVisible,
  setSelectedSubMenuDocumentId,
  setRenamePopupVisible,
  setSelectedDocumentToRename,
  getFile,
  subMenuVisible,
  selectedSubMenuDocumentId,
  setExpiredDocumentsVisible,
}: ExpiredDocumentsTypes) => {
  const {
    expiredDocuments,
    expiredDocumentsPagination,
    expiredDocumentsErrorsList,
  } = useAppSelector((state) => state.customerDocuments);

  const {
    setPage,
    filters,
    formattedExpiredDocumentsData,
    expiredSort,
    expiredDocumentsIsFetching,
    expiredDocumentsIsLoading,
    errorList,
    deleteExpiredDocumentPopupVisible,
    selectedDeleteDocument,
    setDeleteExpiredDocumentPopupVisible,
    onDeleteExpitedDocument,
    deleteExpiredDocumentInProgress,
  } = useExpiredDocuments({
    customerId,
    setDeletePopupVisible,
    deleteDocumentIsSuccess,
    expiredDocuments,
    activePermissions,
    type,
    setSubMenuVisible,
    setSelectedSubMenuDocumentId,
    setRenamePopupVisible,
    setSelectedDocumentToRename,
    getFile,
    subMenuVisible,
    selectedSubMenuDocumentId,
    setExpiredDocumentsVisible,
  });

  return (
    <>
      <button
        type="button"
        className={cn.documentsBackButton}
        onClick={() => setExpiredDocumentsVisible(false)}
      >
        <IconArrowLeft width={13} height={11} />
        Back to documents
      </button>
      <div className={cn.expiredDocumentsTitle}>Expired documents</div>
      <div className={cn.expiredDocumentsTableWrapper}>
        <Table
          take="20"
          setPage={(data) => {
            setPage({
              ...data,
              filters: {
                ...filters,
                status: {
                  value: ['EXPIRED'],
                  type: SchemaFilterType.STRING,
                },
              },
            });
          }}
          tableFormClassName={cn.expiredDocumentsTable}
          tableTopClassName={cn.expiredDocumentsTableTop}
          pagination={expiredDocumentsPagination}
          columns={columns}
          data={formattedExpiredDocumentsData || []}
          onSort={() => {}}
          filters={filters}
          sort={expiredSort}
          columnsLabels={columnsLabels}
          onFilterChange={() => {}}
          isLoading={expiredDocumentsIsFetching || expiredDocumentsIsLoading}
          error={expiredDocumentsErrorsList || errorList}
          clickable
        />
      </div>
      <Popup
        title={`Delete ${selectedDeleteDocument?.name} documents?`}
        onCancelClick={() => {
          setDeleteExpiredDocumentPopupVisible(false);
        }}
        onOkClick={onDeleteExpitedDocument}
        cancelButtonText="Cancel"
        okButtonText={deleteExpiredDocumentInProgress ? 'Loading...' : 'Delete'}
        isVisible={deleteExpiredDocumentPopupVisible}
        isLoading={deleteExpiredDocumentInProgress}
      />
    </>
  );
};

export default ExpiredDocuments;
